import { StoreSettingTypes as Type } from '../../../types/store';

const initialState = {
  merchantAccount: null,
  loading: false,
  error: null,
};

const StoreMerchantAccountReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.CREATE_STORE_MERCHANT_ACCOUNT:
      return { ...state, loading: true, error: null, merchantAccount: null };
    case Type.CREATE_STORE_MERCHANT_ACCOUNT_SUCCESS:
      return {
        ...state,
        merchantAccount: action.payload,
        loading: false,
      };
    case Type.CREATE_STORE_MERCHANT_ACCOUNT_FAILURE:
      return { ...state, error: action.error, loading: false, merchantAccount: null };
    // case Type.RESET_EDIT_STORE_STATE:
    //   return { ...initialState };
    default:
      return state;
  }
};

export default StoreMerchantAccountReducer;
